// "Altri Personaggi" can never be the first crew drawn in a game.
const FIRST_SPIN_EXCLUDED_ID = "others";

// Uniform draw among crews not yet used in the current game (each crew max once per game).
export const drawCrew = (crews, usedCrewIds) => {
  const firstSpin = usedCrewIds.size === 0;
  const eligibleCrews = crews.filter(
    (crew) => !usedCrewIds.has(crew.id) && !(firstSpin && crew.id === FIRST_SPIN_EXCLUDED_ID),
  );
  return eligibleCrews[Math.floor(Math.random() * eligibleCrews.length)];
};
